/* eslint-disable camelcase */
export const check_radio_sheet = require('../../../../static/images/check_radio_sheet.png');
export const close_dialog = require('../../../../static/images/close-dialog.png');
export const close_dialog_2x = require('../../../../static/images/close-dialog@2x.png');
export const drawer_pull = require('../../../../static/images/drawer-pull.png');
export const drawer_pull_x2 = require('../../../../static/images/drawer-pull@x2.png');
export const grabber = require('../../../../static/images/grabber.png');
export const grabber_2x = require('../../../../static/images/grabber@2x.png');
export const layers_white = require('../../../../static/images/layers-white.png');
export const layers_white_2x = require('../../../../static/images/layers-white@2x.png');
export const layers = require('../../../../static/images/layers.png');
export const layers_2x = require('../../../../static/images/layers@2x.png');
export const plane = require('../../../../static/images/plane.png');
export const plane_2x = require('../../../../static/images/plane@2x.png');
export const shadow_0 = require('../../../../static/images/shadow-0.png');
export const shadow_0_2x = require('../../../../static/images/shadow-0@2x.png');
export const shadow_1 = require('../../../../static/images/shadow-1.png');
export const shadow_1_2x = require('../../../../static/images/shadow-1@2x.png');
export const shadow_2 = require('../../../../static/images/shadow-2.png');
export const shadow_2_2x = require('../../../../static/images/shadow-2@2x.png');
export const shadow_3 = require('../../../../static/images/shadow-3.png');
export const shadow_3_2x = require('../../../../static/images/shadow-3@2x.png');
export const shadow_4 = require('../../../../static/images/shadow-4.png');
export const shadow_4_2x = require('../../../../static/images/shadow-4@2x.png');
export const shadow_5 = require('../../../../static/images/shadow-5.png');
export const shadow_5_2x = require('../../../../static/images/shadow-5@2x.png');
export const shadow_6 = require('../../../../static/images/shadow-6.png');
export const shadow_6_2x = require('../../../../static/images/shadow-6@2x.png');
export const shadow_7 = require('../../../../static/images/shadow-7.png');
export const shadow_7_2x = require('../../../../static/images/shadow-7@2x.png');
export const shadow_8 = require('../../../../static/images/shadow-8.png');
export const shadow_8_2x = require('../../../../static/images/shadow-8@2x.png');
export const shadow_9 = require('../../../../static/images/shadow-9.png');
export const shadow_9_2x = require('../../../../static/images/shadow-9@2x.png');
export const tracking_icon_white = require('../../../../static/images/tracking-icon-white.png');
export const tracking_icon_white_2x = require('../../../../static/images/tracking-icon-white@2x.png');
export const tracking_icon = require('../../../../static/images/tracking-icon.png');
export const tracking_icon_2x = require('../../../../static/images/tracking-icon@2x.png');
export const xwing = require('../../../../static/images/xwing/XWing-WHITEwGREYSTROKE.svg');
/*eslint-disable */



// WEBPACK FOOTER //
// ./shared/lib/flick/img/index.js